<template>
  <v-dialog persistent v-model="dialog" max-width="95vw">
    <v-card style="width:95vw; height:90vh; display:flex; flex-direction:column; overflow:hidden;">

      <v-card-text style="flex:1; min-height:0; overflow-y:auto;">
        <v-tabs v-model="activeTab" color="#ff7214" style="margin-bottom:20px;">
          <v-tab value="l1">L1 RULES</v-tab>
          <v-tab value="l3">L3 RULES</v-tab>
          <v-tab value="l4">L4 RULES</v-tab>
        </v-tabs>

        <template v-for="key in ['l1','l3','l4']" :key="key">
          <div v-if="activeTab === key">

            <div style="display:flex; align-items:center; gap:8px;">
              <div
                class="dropzone"
                style="flex:1;"
                :class="dragOver[key] ? 'bg-orange' : 'bg-white'"
                @dragover="onDragOver($event, key)"
                @dragleave="onDragLeave($event, key)"
                @drop="onDrop($event, key)"
              >
                <input
                  type="file"
                  :ref="'file_' + key"
                  accept=".xlsx,.xls"
                  style="opacity:0;display:none;"
                  @change="onFileChange($event, key)"
                />
                <div style="padding:14px 20px; color:gray; display:flex; align-items:center; gap:10px;">
                  <v-icon class="mdi mdi-file-upload-outline" style="color:#ff7214;"></v-icon>
                  <span v-if="!fileNames[key]">Drop {{ key.toUpperCase() }} Excel file here</span>
                  <span v-else style="color:#ff7214; font-weight:500;">{{ fileNames[key] }}</span>
                </div>
              </div>
              <v-btn
                v-if="fileNames[key]"
                icon
                @click="clearFile(key)"
                style="background:#ff7214; color:white; width:32px; height:32px; min-width:0; border-radius:50%; flex-shrink:0;"
              >
                <v-icon style="font-size:16px;">mdi-close</v-icon>
              </v-btn>
            </div>

            <div style="font-size:11px; color:gray; margin-top:4px;">
              Last saved: {{ lastSaved[key] ? Moment(lastSaved[key]).format('MM/DD/YY h:mma') : 'never' }}
            </div>

            <div v-if="errors[key]" style="color:red; font-size:12px; margin-top:8px;">{{ errors[key] }}</div>

            <!-- Current database accordion -->
            <div v-if="currentData[key].length" style="margin-top:10px; border:1px solid #eee; border-radius:4px;">
              <div
                @click="currentExpanded = !currentExpanded"
                style="cursor:pointer; background:#f5f5f5; padding:6px 10px; display:flex; align-items:center; gap:6px; border-radius:4px;"
              >
                <v-icon style="font-size:18px; color:#555;">{{ currentExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                <span style="font-size:12px; font-weight:500; color:#555;">{{ key.toUpperCase() }} Pricing Lookup - Current Database</span>
                <span style="font-size:11px; color:#999; margin-left:6px;">{{ currentData[key].length }} rows</span>
              </div>
              <div v-if="currentExpanded">
                <div style="overflow-x:auto; max-height:400px; overflow-y:auto;">
                  <table style="border-collapse:collapse; font-size:12px; width:100%;">
                    <tbody>
                      <tr v-for="(row, i) in currentData[key]" :key="i">
                        <td style="border:1px solid #eee; padding:5px 10px; white-space:nowrap;">{{ row }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- New file accordion -->
            <div v-if="tableData[key].length" style="margin-top:10px; border:1px solid #eee; border-radius:4px;">
              <div
                @click="newExpanded = !newExpanded"
                style="cursor:pointer; background:#fff8f3; padding:6px 10px; display:flex; align-items:center; gap:6px; border-radius:4px;"
              >
                <v-icon style="font-size:18px; color:#ff7214;">{{ newExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                <span style="font-size:12px; font-weight:500; color:#ff7214;">{{ key.toUpperCase() }} Pricing Lookup - New File To Save</span>
                <span style="font-size:11px; color:#ff9a5c; margin-left:6px;">{{ tableData[key].length }} rows</span>
              </div>
              <div v-if="newExpanded">
                <div style="overflow-x:auto; max-height:400px; overflow-y:auto;">
                  <table style="border-collapse:collapse; font-size:12px; width:100%;">
                    <tbody>
                      <tr v-for="(row, i) in tableData[key]" :key="i">
                        <td style="border:1px solid #eee; padding:5px 10px; white-space:nowrap;">{{ deriveCustomerCategory(row['Price Matrix Combination Description'], key) + ' ' + deriveProduct(row['Price Matrix Combination Description'], key) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <span v-if="savedKeys.length" style="font-size:12px; color:#ff7214; margin-right:10px;">
          Successfully saved: {{ savedKeys.join(', ') }}
        </span>
        <span v-else-if="lookupsToSave.length" style="font-size:14px; font-weight:600; color:gray; margin-right:10px;">
          Rules that will be updated: {{ lookupsToSave.join(', ') }}
        </span>
        <v-btn style="background:gray;color:white;margin-right:6px;" @click="$emit('close')">{{ savedKeys.length && !lookupsToSave.length ? 'CLOSE' : 'CANCEL' }}</v-btn>
        <v-btn
          style="background:#ff7214;color:white;"
          :disabled="!lookupsToSave.length"
          @click="save()"
        >SAVE</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import XLSX from 'xlsx'
import firebase from 'firebase/compat/app'
import { mapGetters } from 'vuex'
import Moment from 'moment'

export default {
  name: 'UpdateL1L3L4RulesPopUp',
  data() {
    return {
      dialog: true,
      activeTab: 'l1',
      dragOver: { l1: false, l3: false, l4: false },
      fileNames: { l1: '', l3: '', l4: '' },
      tableHeaders: { l1: [], l3: [], l4: [] },
      tableData: { l1: [], l3: [], l4: [] },
      errors: { l1: '', l3: '', l4: '' },
      savedKeys: [],
      lastSaved: { l1: null, l3: null, l4: null },
      currentExpanded: true,
      newExpanded: true,
      Moment
    }
  },
  async mounted() {
    const snap = await firebase.database().ref('kpi_settings').once('value')
    const val = snap.val() || {}
    this.lastSaved = {
      l1: val.l1_rules_last_saved || null,
      l3: val.l3_rules_last_saved || null,
      l4: val.l4_rules_last_saved || null
    }
  },
  computed: {
    ...mapGetters(['user', 'l1_lookup', 'l3_lookup', 'l4_lookup']),
    currentData() {
      return { l1: this.l1_lookup, l3: this.l3_lookup, l4: this.l4_lookup }
    },
    lookupsToSave() {
      return ['l1', 'l3', 'l4'].filter(k => this.tableData[k].length > 0).map(k => k.toUpperCase())
    }
  },
  methods: {
    clearFile(key) {
      this.fileNames = { ...this.fileNames, [key]: '' }
      this.tableData = { ...this.tableData, [key]: [] }
      this.tableHeaders = { ...this.tableHeaders, [key]: [] }
      this.errors = { ...this.errors, [key]: '' }
      this.currentExpanded = true
    },
    async save() {
      this.savedKeys = []
      this.$store.state.isLoading = true
      for (const key of ['l1', 'l3', 'l4']) {
        if (!this.tableData[key].length) continue
        const arr = this.tableData[key].map(row => {
          const desc = row['Price Matrix Combination Description']
          return this.deriveCustomerCategory(desc, key) + ' ' + this.deriveProduct(desc, key)
        })
        const ts = Date.now()
        await firebase.database().ref(`kpi_settings/${key}_pricing_lookup`).set(arr)
        await firebase.database().ref(`kpi_settings/${key}_rules_last_saved`).set(ts)
        this.lastSaved = { ...this.lastSaved, [key]: ts }
        this.savedKeys.push(key.toUpperCase())
      }
      this.$store.state.isLoading = false
      this.fileNames = { l1: '', l3: '', l4: '' }
      this.tableHeaders = { l1: [], l3: [], l4: [] }
      this.tableData = { l1: [], l3: [], l4: [] }
      this.errors = { l1: '', l3: '', l4: '' }
      this.$emit('saved')
    },
    deriveCustomerCategory(val, key) {
      if (!val) return ''
      const str = String(val)
      if (key === 'l1') {
        const start = str.indexOf('Customer:(')
        if (start === -1) return ''
        const inner = str.substring(start + 10)
        const end = inner.indexOf(')')
        if (end === -1) return ''
        return inner.substring(0, end).replace(/^0+/, '') || '0'
      }
      return str.substring(11, 15)
    },
    deriveProduct(val, key) {
      if (!val) return ''
      const str = String(val)
      const marker = key === 'l4' ? 'PL:(' : 'Product:('
      const start = str.indexOf(marker)
      if (start === -1) return ''
      const inner = str.substring(start + marker.length)
      const end = inner.indexOf(')')
      return end === -1 ? '' : inner.substring(0, end)
    },
    onDragOver(event, key) {
      event.preventDefault()
      this.dragOver = { ...this.dragOver, [key]: true }
    },
    onDragLeave(event, key) {
      this.dragOver = { ...this.dragOver, [key]: false }
    },
    onDrop(event, key) {
      event.preventDefault()
      this.dragOver = { ...this.dragOver, [key]: false }
      const file = event.dataTransfer.files[0]
      if (file) this.processFile(file, key)
    },
    onFileChange(event, key) {
      const file = event.target.files[0]
      if (file) this.processFile(file, key)
    },
    processFile(file, key) {
      if (key !== this.activeTab) return
      const INVALID_MSG = `Incorrect ${key.toUpperCase()} file`
      const LEVEL_MAP = { l1: 25, l3: 51, l4: 58 }

      this.errors = { ...this.errors, [key]: '' }
      this.tableHeaders = { ...this.tableHeaders, [key]: [] }
      this.tableData = { ...this.tableData, [key]: [] }
      this.fileNames = { ...this.fileNames, [key]: '' }

      const ext = file.name.split('.').pop().toLowerCase()
      if (ext !== 'xlsx' && ext !== 'xls') {
        this.errors = { ...this.errors, [key]: INVALID_MSG }
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheet = workbook.Sheets[workbook.SheetNames[0]]
        const json = XLSX.utils.sheet_to_json(sheet, { defval: '' })

        if (!json.length) {
          this.errors = { ...this.errors, [key]: INVALID_MSG }
          return
        }

        const headers = Object.keys(json[0])
        const hasLevel = headers.includes('Level')
        const hasPMCD = headers.includes('Price Matrix Combination Description')
        if (!hasLevel || !hasPMCD) {
          this.errors = { ...this.errors, [key]: INVALID_MSG }
          return
        }

        const expectedLevel = LEVEL_MAP[key]
        const allMatch = json.every(row => Number(row['Level']) === expectedLevel)
        if (!allMatch) {
          this.errors = { ...this.errors, [key]: INVALID_MSG }
          return
        }

        this.fileNames = { ...this.fileNames, [key]: file.name }
        this.tableHeaders = { ...this.tableHeaders, [key]: headers }
        this.tableData = { ...this.tableData, [key]: json }
        this.savedKeys = []
        this.currentExpanded = false
        this.newExpanded = true
      }
      reader.readAsArrayBuffer(file)
    }
  }
}
</script>

<style scoped>
  .dropzone {
    width: 100%;
    height: 55px;
    border: 2px dashed orange;
    border-radius: 4px;
    cursor: pointer;
  }
  .bg-white { background: white; }
  .bg-orange { background: orange; }
</style>
